<!-- 设备保养记录 -->
<style>
.baoyangxianginput {
  width: 1.25rem;
}
.state {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: center;
}
</style>
<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/mould/resume/pageRepairRecord" getKey="rows" :columns="columns">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item class="noborder" :label="$t('mujubianma/mingcheng')">
            <yi_cross_select disabled :selectTitle="'code,name'" multiple :component="'web_base_mould_list'" :ids.sync="$attrs.repairRecord.mouldId"> </yi_cross_select>
          </el-form-item>
          <el-form-item :label="$t('dangnianleijiweixiucishu')" label-width="230px">
            {{ yt.total }} </el-form-item
          ><br />
          <el-form-item :label="$t('nianfen')">
            <yi_time_input format="yyyy" :type="'year'" :time.sync="yt.conditions.year" :clearable="false"> </yi_time_input>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain="plain">
              {{ $t('sousuo') }}
            </el-button>
            <el-button @click="reset()">{{ $t('chongzhi') }} </el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1" v-if="scope.row.status == 2">
            <el-button
              type="text"
              @click="
                yt.showEditDialog('weixiuxiangqing', scope.row, 'w2');
                getRepairMethodItem(scope.row);
              "
            >
              {{ $t('weixiuxiangqing') }}
            </el-button>
          </el-col>
        </el-row>
      </template>
      <!-- 送修类型 -->
      <template #songxiuleixing="scope">
        <span v-if="scope.row.repairType === 0">{{ $t('xiumu') }}</span>
        <span v-if="scope.row.repairType === 1">{{ $t('gaimu') }}</span>
      </template>
      <template #jinjichengdu="scope">
        <template v-if="scope.row.level == 0">
          <div class="state">
            <span style="width: 8px;height: 8px;border-radius: 50%;background-color: #909399;"></span>
            <span style="margin-left: 5px;">{{ $t('yiban') }}</span>
          </div>
        </template>
        <template v-if="scope.row.level == 1">
          <div class="state">
            <span style="width: 8px;height: 8px;border-radius: 50%;background-color: #E6A23C;"></span>
            <span style="margin-left: 5px;">{{ $t('jinji') }}</span>
          </div>
        </template>
        <template v-if="scope.row.level == 2">
          <div class="state">
            <span style="width: 8px;height: 8px;border-radius: 50%;background-color: #F56C6C;"></span>
            <span style="margin-left: 5px;">{{ $t('teji') }}</span>
          </div>
        </template>
      </template>
      <template #tupian="scope">
        <yi_upload :readOnly="true" :ids.sync="scope.row.imgInfoIds" :limit="5"> </yi_upload>
      </template>
    </yi_curd_table>
    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog" :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
      <!-- "维修详情"-->
      <template v-if="yt.editObj.action == 'weixiuxiangqing'">
        <div class="dialog-scroller">
          <el-form :inline="true" ref="form" size="mini" style="margin-left: -120px;margin-top: 50px;">
            <!-- 备注 -->
            <el-form-item style="margin-left: -200px;" :label="$t('beizhu')" label-width="410px" size="mini">
              {{ yt.editObj.repairRemark }} </el-form-item
            ><br />
            <div style="display: flex;flex-wrap: nowrap;">
              <div style="margin-left: -68px;">
                <el-form-item :label="$t('weixiufangfa')" required label-width="310px"> </el-form-item>
              </div>
              <div style="margin-left: -10px;">
                <el-form-item :label="$t('weixiushuoming')" required label-width="210px"> </el-form-item>
              </div>
              <div style="margin-left: -10px;">
                <el-form-item :label="$t('shangchuantupian')" label-width="210px"> </el-form-item>
              </div>
            </div>
          </el-form>
          <el-form style="margin-left: -140px;">
            <el-form-item v-for="(item, index) in yt.editObj.repairRecordDetails" label-width="180px" size="mini">
              <el-col :span="0.1">&nbsp;</el-col>
              <el-col :span="4">
                <el-input :value="item.repairMethodName" />
              </el-col>
              <el-col :span="3">&nbsp;</el-col>
              <el-col :span="3">
                <el-input :value="item.repairDescription" type="text" size="mini"> </el-input>
              </el-col>
              <el-col :span="4">&nbsp;</el-col>
              <el-col :span="3">
                <yi_upload style="margin-top: -10px;" :readOnly="true" :ids.sync="item.imgInfoIds" :limit="5"></yi_upload>
              </el-col>
            </el-form-item>
          </el-form>
        </div>
      </template>
    </el-dialog>
  </div>
</template>
<script type="text/javascript">
// import maintenance_item from '@@/pages/web/equipment/maintenance/maintenance_item'
export default {
  name: 'web_mold_management_resume_repair_record',
  components: {
    // maintenance_item
  },
  data() {
    return {
      leaveFactoryDate: new Date().getFullYear() + '-' + (new Date().getMonth() + 1) + '-' + new Date().getDate(),
      list: [],
      repairMethod: [],
      repairRecordDetails: [],
      columns: [
        {
          label: 'mujuweixiudanhao',
          prop: 'repairNo',
          fixed: 'left',
          width: 180
        },
        {
          label: 'songxiuleixing',
          prop: 'repairType',
          type: 'slot'
        },
        {
          label: 'jinjichengdu',
          prop: 'level',
          type: 'slot'
        },
        {
          label: 'shenqingren',
          prop: 'createByObject.nickname'
        },
        {
          label: 'chuangjianshijian',
          prop: 'createTime',
          type: 'time',
          width: 230
        },
        {
          label: 'miaoshu',
          prop: 'faultDescription'
        },
        {
          label: 'weixiuzhuangtai',
          type: 'tag',
          prop: 'status',
          tags: {
            0: {
              color: '#F56C6C',
              text: this.$t('daichuli')
            },
            1: {
              color: '#E6A23C',
              text: this.$t('chulizhong')
            },
            2: {
              color: '#67C23A',
              text: this.$t('yiwancheng')
            }
          }
        },
        {
          label: 'weixiushifu',
          prop: 'repairer'
        },
        {
          label: 'weixiukaishishijian',
          prop: 'beginTime',
          type: 'time',
          width: 180
        },
        {
          label: 'weixiujieshushijian',
          prop: 'endTime',
          type: 'time',
          width: 180
        },
        {
          label: 'tupian',
          type: 'slot',
          width: 150
        },
        {
          label: 'caozuo',
          type: 'slot',
          width: 160,
          fixed: 'right'
        }
      ]
    };
  },
  created() {
    setTimeout(() => {
      this.yt.conditions.mouldIds = this.$attrs.repairRecord.mouldIds;
      this.yt.conditions = {
        orderBy: 'createTime desc',
        moldId: this.$attrs.repairRecord.mould.id
      };
      this.setDefaultTime();
      this.yt.get(1);
      this.getRepairMethod();
    }, 300);
  },
  watch: {
    'yt.editObj.action': {
      handler(n) {
        if (n === 'wanchengweixiu') {
          this.$set(this.yt.editObj, 'methodList', [
            {
              label: '',
              id: 0
            }
          ]);
        }
      },
      immediate: false,
      deep: true
    }
  },
  methods: {
    //重置按钮
    reset() {
      this.setDefaultTime();
      this.yt.get(1);
    },
    // 请求查询客户数据字典中的维修方法项
    async getRepairMethod() {
      let response = await this.http.get('/web/config/customer/dictionary/item/getDictionaryByTypeCode', {
        params: {
          code: 'MJWXFF'
        }
      });
      this.repairMethod = response.data;
    },
    // 开始维修
    startRepair(editObj) {
      this.http
        .post('/web/equipment/repair/bill/start', {
          id: editObj.id
        })
        .then(res => {
          this.utils.successMessage(this.$t(res.msg));
          this.yt.get(1);
        })
        .catch(msg => {
          this.utils.errorMessage(msg);
        });
    },
    // 添加维修方法项
    addItem() {
      this.yt.editObj.methodList.push({
        method: '',
        remark: ''
      });
    },
    // 删除维修方法项
    deleteItem(key) {
      this.yt.editObj.methodList = this.yt.editObj.methodList.filter((item, index) => {
        return index !== key;
      });
    },
    // 根据维修记录id查询已成功完成维修的维修详情
    async getRepairMethodItem(obj) {
      let response = await this.http.get('/web/equipment/repair/bill/listMethod', {
        params: {
          repairId: obj.id
        }
      });
      this.repairRecordDetails = response.data;
      console.log('itemList:', this.repairRecordDetails);
    },
    setDefaultTime() {
      var currentMonthDate = new Date();
      currentMonthDate.setDate(1);
      currentMonthDate.setHours(0);
      currentMonthDate.setSeconds(0);
      currentMonthDate.setMinutes(0);
      currentMonthDate.setMilliseconds(0);
      this.yt.conditions.year = currentMonthDate.getTime();
    }
  }
};
</script>
